import React from "react";

const EditReminderRow = (props) => (
  <svg width={21} height={21} viewBox="0 0 21 21" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 11C18.4477 11 18 11.4477 18 12V18C18 18.5523 17.5523 19 17 19H3C2.44772 19 2 18.5523 2 18V4C2 3.44772 2.44772 3 3 3H9C9.55229 3 10 2.55228 10 2C10 1.44772 9.55229 1 9 1H3C1.34315 1 0 2.34315 0 4V18C0 19.6569 1.34315 21 3 21H17C18.6569 21 20 19.6569 20 18V12C20 11.4477 19.5523 11 19 11ZM4 11.76V16C4 16.5523 4.44772 17 5 17H9.24C9.5058 17.0015 9.76128 16.8972 9.95 16.71L16.87 9.78L19.71 7C19.8993 6.81223 20.0058 6.55664 20.0058 6.29C20.0058 6.02336 19.8993 5.76777 19.71 5.58L15.47 1.29C15.2822 1.10069 15.0266 0.994202 14.76 0.994202C14.4934 0.994202 14.2378 1.10069 14.05 1.29L11.23 4.12L4.29 11.05C4.10281 11.2387 3.99846 11.4942 4 11.76ZM14.76 3.41L17.59 6.24L16.17 7.66L13.34 4.83L14.76 3.41ZM6 12.17L11.93 6.24L14.76 9.07L8.83 15H6V12.17Z"
      fill="#6A6A6A"
    />
  </svg>
);

export default EditReminderRow;
